import axios,{ secondAxios } from "../../../../api/axios";

export const getProject = async ({ projectId }) => {
  try {
    const res = await secondAxios.get("/project/" + projectId + "/mcs");
    // console.log('res', res);

    return res.data;
  } catch (error) {
    console.log(error);
  }
};
export const postMaterials = async (equipWithMaterial) => {
  const postMaterials = "/materialdb/postEquipMaterial";
  const { data } = await axios.post(postMaterials, equipWithMaterial);

  console.log({ data });
  return data;
};

export const getProjectWithEquip = async (projectId, equipId) => {
  const getProjectWithEquipApi = "/mcs_project"
  const { data } = await axios.get(`${getProjectWithEquipApi}/${projectId}/${equipId}`);
  
  console.log({ data });
  return data;
}
 export async function postAllData(projectId, formattedData) {
 const res = await secondAxios.post(
      `project/component/${projectId}/PV/all`,
      formattedData
    );
    return res.data;
 }
 export async function getAllData(projectId) {
 const res = await secondAxios.get(
      `project/component/${projectId}/PV/all`,
    );
    return res.data;
 }
 export async function getShellDesign(projectId) {
 const res =await secondAxios.get(
        `project/component/${projectId}/pv/shellDesign`
      );
    return res;
 }
 export async function postShellDesign(projectId, formattedData) {
const res = await secondAxios.post(
       `project/component/${projectId}/pv/shellDesign`,
       formattedData
     );
   return res.data;
}
  export async function getNozzlesDesign(projectId) {
 const res =await secondAxios.get(
        `project/component/${projectId}/pv/nozzlesDesign`
      );
    return res;
 }
 export async function postNozzlesDesign(projectId, formattedData) {
const res = await secondAxios.post(
       `project/component/${projectId}/pv/nozzlesDesign`,
       formattedData
     );
   return res.data;
}
export async function getPvPlantProjects(plantId, clientName) {
  const res = await secondAxios.get(
    `project/plant/${plantId}/${clientName}?type=pv`,
  );
  return res.data;
}
export async function getProjectById(projectId) {
  const response = await secondAxios.get(
    `/project/${projectId}?revisions=true&users=true`,
  );
  // console.log("response", { response });
  if (typeof response.data?.data === "string") {
    return JSON.parse(response.data?.data);
  }
  return response?.data;
}

export async function getPlantById(plantId) {
  const res = await secondAxios.get(`/plant/${plantId}`);
  return res.data;
}
